'use strict';

angular.module('DoohApps').directive('showMedia', ['$parse', 'DoohConfig', '$timeout', function ($parse, DoohConfig, $timeout) {
    return {
        scope: {
            mediaUrl: '@',
            iconUrl: '@',
            thumbnail: '=',
            autoplayVideo: '=',
            displayError: '=',
            pauseVideo: '=',
            onMediaLoaded: '&'
        },
        link: function (scope, elem) {
            $timeout(function () {
                setTypes(scope.mediaUrl);
            });

            function setTypes(mediaUrl) {

                scope.mediaLoaded = false;
                scope.mediaType = mediaUrl.split('.').pop();
                switch (scope.mediaType) {
                    case 'jpg':
                    case 'jpeg':
                    case 'png':
                    case 'gif':
                    case 'bmp':
                        scope.templateType = scope.mediaType = 'image';
                        if (scope.thumbnail) {
                            scope.templateType = 'thumbnail';
                            loadImage(scope.iconUrl);
                        }
                        else {
                            loadImage(scope.mediaUrl);
                        }
                        break;
                    case 'mp4':
                    case 'webm':
                    case 'ogg':
                        scope.templateType = scope.mediaType = 'video';
                        if (scope.thumbnail) {
                            scope.templateType = 'thumbnail';
                            loadImage(scope.iconUrl);
                        }
                        else {
                            if (scope.autoplayVideo) {
                                $timeout(loadVideo);
                            }
                            else {
                                if (scope.iconUrl != undefined)
                                    loadImage(scope.iconUrl);
                                else
                                    mediaLoaded();
                            }
                        }
                        break;
                    default:
                        if (scope.thumbnail) {
                            scope.templateType = 'thumbnail';
                            scope.onMediaLoaded({ value: true });
                        }
                        else {
                            scope.templateType = 'error';
                            mediaLoaded();
                        }
                        break;
                }
            }

            function loadImage(url) {
                var img = new Image();
                img.src = url;
                img.onload = function () {
                    mediaLoaded(true);
                }
                img.onerror = function () {
                    mediaLoaded(true);
                }
            }

            function loadVideo() {
                var vid = elem.find('video[autoplay]');
                vid.on('loadeddata', function (event) {
                    mediaLoaded(true);
                });
            }

            function mediaLoaded(needApply) {
                scope.mediaLoaded = true;
                scope.onMediaLoaded({ value: true });
                if (needApply)
                    scope.$apply();
            }

            scope.$watch(function () { return scope.mediaUrl }, function (newValue, oldValue) {
                if (newValue != oldValue)
                    setTypes(newValue);
            });

            if (scope.pauseVideo != undefined)
                scope.$watch(function () { return scope.pauseVideo }, function (newValue, oldValue) {
                    if (newValue != oldValue && newValue && scope.templateType == 'video') {
                        elem.find('video').get(0).pause();
                    }
                });
        },
        templateUrl: '../../../Templates/Partials/Templates/showMedia.html?v=' + DoohConfig.version
    }
}]);